import React from 'react';
import { Link } from 'react-router-dom';
import type { DocumentType } from '../types';
import Icon from './Icon';

interface DocumentCardProps {
  doc: DocumentType;
}

const DocumentCard: React.FC<DocumentCardProps> = ({ doc }) => {
  return (
    <div className="w-72 sm:w-auto flex-shrink-0 bg-[var(--color-surface)] rounded-xl shadow-lg transition-all duration-300 flex flex-col p-6 border border-[var(--color-border)] hover:border-[var(--color-primary)]">
      <div className="flex items-center gap-4 mb-4">
        <div className="p-3 rounded-full bg-[var(--color-primary-light)]">
          {/* Fix: Removed 'as any' as doc.iconName is now correctly typed as IconName. */}
          <Icon name={doc.iconName} className="w-6 h-6 text-[var(--color-primary)]" />
        </div>
        <h3 className="text-lg font-bold text-[var(--color-text-heading)]">{doc.title}</h3>
      </div>
      <p className="text-[var(--color-text-body)] flex-grow mb-6">{doc.description}</p>
      <Link
        to={`/generate/${doc.id}`}
        className="mt-auto w-full text-center bg-[var(--color-primary)] text-[var(--color-white)] font-semibold py-2 px-4 rounded-lg hover:bg-[var(--color-primary-hover)] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--color-primary)]"
      >
        إنشاء الصفحة
      </Link>
    </div>
  );
};

export default DocumentCard;
